<template>
    <div class="tree-ul-line">
        <div v-if="mode['flag']"
             class="tree-ul-country-flag"
        >
        </div>
        <CheckBox :title="setCheckBoxTitle"
                  :chosen="nodeValue.isChosen"
                  :old-design="oldDesign"
                  :partiallyFill="nodeValue.isPartiallyChosen"
                  :htmlTitle="mode['highlight']
                                || Object.keys(styled).length > 0"
                  :mode="innerCheckboxMode"
                  @change="choose({level: nodeValue.nodeLevel, id: nodeValue.obj.id})"
        />
    </div>
</template>

<script>
    import CheckBox from '../checkbox/CheckBox';
    import DecorateHelper from '../../utils/reusable-helpers/DecorateHelper';

    export default {
        name: "HighLightedCheckBox",
        components: {CheckBox},
        props: {
            nodeValue: Object,
            searchText: String,
            mode: {
                type: Object,
                default: () => {
                    return {
                        flag: false,
                        highlight: false
                    }
                }
            },
            oldDesign: Boolean,
            innerCheckboxMode: {
                type: Array,
            },
            styled: {
                type: Object,
                required: false,
                default () {
                    return {}
                }
            }
        },
        computed: {
            getRegExpForSearchText() {
              const letters = [
                ['ё', 'е'],
                ['ь', 'ъ'],
              ];

              return this.searchText
                  .toLowerCase()
                  .split('')
                  .map((letter) => {
                    const exceptionLetters = letters.find((array) => array.includes(letter));
                    return exceptionLetters ? `(${exceptionLetters[0]}|${exceptionLetters[1]})` : letter;
                  })
                  .join('');
            },
            setCheckBoxTitle () {
                let title = this.nodeValue.obj.name;
                if (this.searchText !== '') {
                    let checkBoxName = title.toLowerCase();

                    if (this.mode['highlight'] && checkBoxName.match(this.getRegExpForSearchText)) {
                        title = DecorateHelper.highLightControlTitle(
                            title,
                            this.getRegExpForSearchText,
                            '#839f2280',
                            'inherit'
                        );
                    }
                }

                if (Object.keys(this.styled).length > 0) {
                    switch (this.styled.styleType) {
                        case 'highlight': {
                            title = DecorateHelper.highLightControlTitle(
                                title,
                                title,
                                this.styled.backgroundColor,
                                this.styled.textColor
                            );
                            break;
                        }
                        case 'bold': {
                            title = DecorateHelper.boldControlTitle(title);
                            break;
                        }
                        default: break;
                    }
                }

                return title;
            },
        },
        methods: {
            choose (node) {
                this.$emit('choose-node', node);
            },
        }
    }
</script>

<style scoped>
    .tree-ul-line {
        display: flex;
        flex-direction: row;
    }

    .tree-ul-country-flag {
        background-image: url("./assets/russia_flag_icon.png");
        background-repeat: no-repeat;
        background-size: 24px;
        width: 24px;
        height: 16px;
        margin-right: 5px;
    }
</style>
